<template>
  <div class="dashboard-form-submissions-detail">
    <div v-if="submission" class="md-layout md-alignment-top-left">
      <div class="md-layout-item md-size-80">
        <div class="title">
          {{submission.content.email}}
        </div>
      </div>
      <div class="md-layout-item md-size-20 align-right">
        {{new Date(submission.created_at).toLocaleDateString()}}
      </div>
      <div class="md-layout-item md-size-100">
        <highlight-block-code :code="jsonContent" :show-line-breaks="true"></highlight-block-code>
      </div>
      <div v-if="submission.files && submission.files.length>0" class="md-layout-item md-size-100">
        <h4>Uploads</h4>
        <div
          v-for="file in submission.files"
          :key="file.id"
        >
          <div>
            <strong>
              {{file.fieldName | capitalize }}:
            </strong>
          </div>
          <div>
            <a class="download-link" :href="makeDownloadUrl(file)" target="_blank">
              {{file.clientName}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HighlightBlockCode from '../HighlightBlockCode'

export default {
  name: 'DashboardFormSubmissionsDetail',
  components: {
    HighlightBlockCode
  },
  computed: {
    base_url_form () {
      return this.$store.getters['base_url_form']
    },
    submission () {
      return this.$store.getters['currentSubmission']
    },
    jsonContent () {
      let json = JSON.stringify(this.submission.content)

      const push = function (m) { return '\\' + p.push(m) + '\\' }
      const pop = function (m, i) { return p[i - 1] }
      const tabs = function (count) { return new Array(count + 1).join('  ') }
      let p = []
      let out = ''
      let indent = 0

      // Extract backslashes and strings
      json = json
        .replace(/\\./g, push)
        .replace(/(".*?"|'.*?')/g, push)
        .replace(/\s+/, '')

      // Indent and insert newlines
      for (let i = 0; i < json.length; i++) {
        var c = json.charAt(i)

        switch (c) {
          case '{':
          case '[':
            out += c + '\n' + tabs(++indent)
            break
          case '}':
          case ']':
            out += '\n' + tabs(--indent) + c
            break
          case ',':
            out += ',\n' + tabs(indent)
            break
          case ':':
            out += ': '
            break
          default:
            out += c
            break
        }
      }

      // Strip whitespace from numeric arrays and put backslashes
      // and strings back in
      out = out
        .replace(/\[[\d,\s]+?\]/g, function (m) { return m.replace(/\s/g, '') })
        .replace(/\\(\d+)\\/g, pop) // strings
        .replace(/\\(\d+)\\/g, pop) // backslashes in strings

      return out
    }
  },
  methods: {
    makeDownloadUrl (file) {
      return `${this.base_url_form}/files/${file.token}`
    }
  }
}
</script>

<style lang="scss" scoped>

.dashboard-form-submissions-detail {
  padding: 30px;
  background:whitesmoke;
  border-radius: 10px;
}
.title {
  font-weight: bold;
}
.download-link {
  word-wrap: break-word;
}
.align-right {
  text-align: end;
}
</style>



// WEBPACK FOOTER //
// src/components/views/DashboardFormSubmissionsDetail.vue